/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChatCostResponse } from '../models';
// @ts-ignore
import type { ChatCountResponse } from '../models';
// @ts-ignore
import type { ChatCreate } from '../models';
// @ts-ignore
import type { ChatOut } from '../models';
// @ts-ignore
import type { ChatUpdate } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bulk soft delete chats by session IDs.
         * @param {Array<string | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteChats: async (requestBody: Array<string | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkDeleteChats', 'requestBody', requestBody)
            const localVarPath = `/api/v1/chats/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete all non-deleted chats for a specific agent.  Example: DELETE /api/v1/chats/all?agent_id=your-agent-id
         * @summary Soft delete all chats for a specific agent by setting is_deleted to True.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllChats: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('deleteAllChats', 'agentId', agentId)
            const localVarPath = `/api/v1/chats/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft delete a chat by its `session_id`. Returns success message if deleted, otherwise 404.
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChat: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('deleteChat', 'sessionId', sessionId)
            const localVarPath = `/api/v1/chats/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all non-deleted chats.
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChats: async (skip?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a chat object by its `session_id`. Returns 404 if not found.
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChat: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getChat', 'sessionId', sessionId)
            const localVarPath = `/api/v1/chats/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated non-deleted chats for a specific agent.  Example: /api/v1/chats/agent/your-agent-id?skip=0&limit=10
         * @summary Retrieve paginated non-deleted chats for a specific agent.
         * @param {string} agentId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsByAgentId: async (agentId: string, skip?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getChatsByAgentId', 'agentId', agentId)
            const localVarPath = `/api/v1/chats/agent/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate invoice cost for chats within a specific time frame.
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} organizationId Organization ID (required)
         * @param {string | null} [agentId] Optional agent filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsCost: async (startDate: string, endDate: string, organizationId: string, agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getChatsCost', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getChatsCost', 'endDate', endDate)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getChatsCost', 'organizationId', organizationId)
            const localVarPath = `/api/v1/chats/cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get count of all chats (including deleted) within a time frame. Can filter by agent_id and/or organization_id.  Note: When end_date is at 00:00:00 (start of a day), it will be adjusted to include the whole day. For example, if end_date is 2026-01-08T00:00:00.000Z, it will count all chats up to the end of Jan 8 (2026-01-08T23:59:59.999Z).  Example: /api/v1/chats/count?start_date=2026-01-07T00:00:00&end_date=2026-01-08T00:00:00&organization_id=org-123 This will count all chats for the whole days of Jan 7 and Jan 8.
         * @summary Get count of chats within a specific time frame.
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string | null} [agentId] Optional agent filter
         * @param {string | null} [organizationId] Optional organization filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsCount: async (startDate: string, endDate: string, agentId?: string | null, organizationId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getChatsCount', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getChatsCount', 'endDate', endDate)
            const localVarPath = `/api/v1/chats/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the chat fields such as `forced_transfer_count` or `is_transfer` for the given `session_id`.
         * @param {string} sessionId 
         * @param {ChatUpdate} chatUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChat: async (sessionId: string, chatUpdate: ChatUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('updateChat', 'sessionId', sessionId)
            // verify required parameter 'chatUpdate' is not null or undefined
            assertParamExists('updateChat', 'chatUpdate', chatUpdate)
            const localVarPath = `/api/v1/chats/{session_id}`
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new chat if the given `session_id` does not exist. If it already exists, update the `is_transfer` field instead.
         * @param {ChatCreate} chatCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertChat: async (chatCreate: ChatCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatCreate' is not null or undefined
            assertParamExists('upsertChat', 'chatCreate', chatCreate)
            const localVarPath = `/api/v1/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bulk soft delete chats by session IDs.
         * @param {Array<string | null>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteChats(requestBody: Array<string | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteChats(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.bulkDeleteChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete all non-deleted chats for a specific agent.  Example: DELETE /api/v1/chats/all?agent_id=your-agent-id
         * @summary Soft delete all chats for a specific agent by setting is_deleted to True.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllChats(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllChats(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.deleteAllChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Soft delete a chat by its `session_id`. Returns success message if deleted, otherwise 404.
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChat(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChat(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.deleteChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve all non-deleted chats.
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChats(skip?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChats(skip, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getAllChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve a chat object by its `session_id`. Returns 404 if not found.
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChat(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChat(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated non-deleted chats for a specific agent.  Example: /api/v1/chats/agent/your-agent-id?skip=0&limit=10
         * @summary Retrieve paginated non-deleted chats for a specific agent.
         * @param {string} agentId 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatsByAgentId(agentId: string, skip?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatsByAgentId(agentId, skip, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatsByAgentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate invoice cost for chats within a specific time frame.
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} organizationId Organization ID (required)
         * @param {string | null} [agentId] Optional agent filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatsCost(startDate: string, endDate: string, organizationId: string, agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatCostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatsCost(startDate, endDate, organizationId, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatsCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get count of all chats (including deleted) within a time frame. Can filter by agent_id and/or organization_id.  Note: When end_date is at 00:00:00 (start of a day), it will be adjusted to include the whole day. For example, if end_date is 2026-01-08T00:00:00.000Z, it will count all chats up to the end of Jan 8 (2026-01-08T23:59:59.999Z).  Example: /api/v1/chats/count?start_date=2026-01-07T00:00:00&end_date=2026-01-08T00:00:00&organization_id=org-123 This will count all chats for the whole days of Jan 7 and Jan 8.
         * @summary Get count of chats within a specific time frame.
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string | null} [agentId] Optional agent filter
         * @param {string | null} [organizationId] Optional organization filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatsCount(startDate: string, endDate: string, agentId?: string | null, organizationId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatsCount(startDate, endDate, agentId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.getChatsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the chat fields such as `forced_transfer_count` or `is_transfer` for the given `session_id`.
         * @param {string} sessionId 
         * @param {ChatUpdate} chatUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChat(sessionId: string, chatUpdate: ChatUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChat(sessionId, chatUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.updateChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new chat if the given `session_id` does not exist. If it already exists, update the `is_transfer` field instead.
         * @param {ChatCreate} chatCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertChat(chatCreate: ChatCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertChat(chatCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.upsertChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * 
         * @summary Bulk soft delete chats by session IDs.
         * @param {ChatApiBulkDeleteChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteChats(requestParameters: ChatApiBulkDeleteChatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bulkDeleteChats(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete all non-deleted chats for a specific agent.  Example: DELETE /api/v1/chats/all?agent_id=your-agent-id
         * @summary Soft delete all chats for a specific agent by setting is_deleted to True.
         * @param {ChatApiDeleteAllChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllChats(requestParameters: ChatApiDeleteAllChatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAllChats(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft delete a chat by its `session_id`. Returns success message if deleted, otherwise 404.
         * @param {ChatApiDeleteChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChat(requestParameters: ChatApiDeleteChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteChat(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all non-deleted chats.
         * @param {ChatApiGetAllChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChats(requestParameters: ChatApiGetAllChatsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatOut>> {
            return localVarFp.getAllChats(requestParameters.skip, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a chat object by its `session_id`. Returns 404 if not found.
         * @param {ChatApiGetChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChat(requestParameters: ChatApiGetChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatOut> {
            return localVarFp.getChat(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated non-deleted chats for a specific agent.  Example: /api/v1/chats/agent/your-agent-id?skip=0&limit=10
         * @summary Retrieve paginated non-deleted chats for a specific agent.
         * @param {ChatApiGetChatsByAgentIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsByAgentId(requestParameters: ChatApiGetChatsByAgentIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getChatsByAgentId(requestParameters.agentId, requestParameters.skip, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate invoice cost for chats within a specific time frame.
         * @param {ChatApiGetChatsCostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsCost(requestParameters: ChatApiGetChatsCostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatCostResponse> {
            return localVarFp.getChatsCost(requestParameters.startDate, requestParameters.endDate, requestParameters.organizationId, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get count of all chats (including deleted) within a time frame. Can filter by agent_id and/or organization_id.  Note: When end_date is at 00:00:00 (start of a day), it will be adjusted to include the whole day. For example, if end_date is 2026-01-08T00:00:00.000Z, it will count all chats up to the end of Jan 8 (2026-01-08T23:59:59.999Z).  Example: /api/v1/chats/count?start_date=2026-01-07T00:00:00&end_date=2026-01-08T00:00:00&organization_id=org-123 This will count all chats for the whole days of Jan 7 and Jan 8.
         * @summary Get count of chats within a specific time frame.
         * @param {ChatApiGetChatsCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatsCount(requestParameters: ChatApiGetChatsCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatCountResponse> {
            return localVarFp.getChatsCount(requestParameters.startDate, requestParameters.endDate, requestParameters.agentId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the chat fields such as `forced_transfer_count` or `is_transfer` for the given `session_id`.
         * @param {ChatApiUpdateChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChat(requestParameters: ChatApiUpdateChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatOut> {
            return localVarFp.updateChat(requestParameters.sessionId, requestParameters.chatUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new chat if the given `session_id` does not exist. If it already exists, update the `is_transfer` field instead.
         * @param {ChatApiUpsertChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertChat(requestParameters: ChatApiUpsertChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatOut> {
            return localVarFp.upsertChat(requestParameters.chatCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkDeleteChats operation in ChatApi.
 * @export
 * @interface ChatApiBulkDeleteChatsRequest
 */
export interface ChatApiBulkDeleteChatsRequest {
    /**
     * 
     * @type {Array<string | null>}
     * @memberof ChatApiBulkDeleteChats
     */
    readonly requestBody: Array<string | null>
}

/**
 * Request parameters for deleteAllChats operation in ChatApi.
 * @export
 * @interface ChatApiDeleteAllChatsRequest
 */
export interface ChatApiDeleteAllChatsRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiDeleteAllChats
     */
    readonly agentId: string
}

/**
 * Request parameters for deleteChat operation in ChatApi.
 * @export
 * @interface ChatApiDeleteChatRequest
 */
export interface ChatApiDeleteChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiDeleteChat
     */
    readonly sessionId: string
}

/**
 * Request parameters for getAllChats operation in ChatApi.
 * @export
 * @interface ChatApiGetAllChatsRequest
 */
export interface ChatApiGetAllChatsRequest {
    /**
     * 
     * @type {number}
     * @memberof ChatApiGetAllChats
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof ChatApiGetAllChats
     */
    readonly limit?: number
}

/**
 * Request parameters for getChat operation in ChatApi.
 * @export
 * @interface ChatApiGetChatRequest
 */
export interface ChatApiGetChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChat
     */
    readonly sessionId: string
}

/**
 * Request parameters for getChatsByAgentId operation in ChatApi.
 * @export
 * @interface ChatApiGetChatsByAgentIdRequest
 */
export interface ChatApiGetChatsByAgentIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatsByAgentId
     */
    readonly agentId: string

    /**
     * 
     * @type {number}
     * @memberof ChatApiGetChatsByAgentId
     */
    readonly skip?: number

    /**
     * 
     * @type {number}
     * @memberof ChatApiGetChatsByAgentId
     */
    readonly limit?: number
}

/**
 * Request parameters for getChatsCost operation in ChatApi.
 * @export
 * @interface ChatApiGetChatsCostRequest
 */
export interface ChatApiGetChatsCostRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatsCost
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatsCost
     */
    readonly endDate: string

    /**
     * Organization ID (required)
     * @type {string}
     * @memberof ChatApiGetChatsCost
     */
    readonly organizationId: string

    /**
     * Optional agent filter
     * @type {string}
     * @memberof ChatApiGetChatsCost
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for getChatsCount operation in ChatApi.
 * @export
 * @interface ChatApiGetChatsCountRequest
 */
export interface ChatApiGetChatsCountRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatsCount
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof ChatApiGetChatsCount
     */
    readonly endDate: string

    /**
     * Optional agent filter
     * @type {string}
     * @memberof ChatApiGetChatsCount
     */
    readonly agentId?: string | null

    /**
     * Optional organization filter
     * @type {string}
     * @memberof ChatApiGetChatsCount
     */
    readonly organizationId?: string | null
}

/**
 * Request parameters for updateChat operation in ChatApi.
 * @export
 * @interface ChatApiUpdateChatRequest
 */
export interface ChatApiUpdateChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatApiUpdateChat
     */
    readonly sessionId: string

    /**
     * 
     * @type {ChatUpdate}
     * @memberof ChatApiUpdateChat
     */
    readonly chatUpdate: ChatUpdate
}

/**
 * Request parameters for upsertChat operation in ChatApi.
 * @export
 * @interface ChatApiUpsertChatRequest
 */
export interface ChatApiUpsertChatRequest {
    /**
     * 
     * @type {ChatCreate}
     * @memberof ChatApiUpsertChat
     */
    readonly chatCreate: ChatCreate
}

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * 
     * @summary Bulk soft delete chats by session IDs.
     * @param {ChatApiBulkDeleteChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public bulkDeleteChats(requestParameters: ChatApiBulkDeleteChatsRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).bulkDeleteChats(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete all non-deleted chats for a specific agent.  Example: DELETE /api/v1/chats/all?agent_id=your-agent-id
     * @summary Soft delete all chats for a specific agent by setting is_deleted to True.
     * @param {ChatApiDeleteAllChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public deleteAllChats(requestParameters: ChatApiDeleteAllChatsRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).deleteAllChats(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft delete a chat by its `session_id`. Returns success message if deleted, otherwise 404.
     * @param {ChatApiDeleteChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public deleteChat(requestParameters: ChatApiDeleteChatRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).deleteChat(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all non-deleted chats.
     * @param {ChatApiGetAllChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getAllChats(requestParameters: ChatApiGetAllChatsRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getAllChats(requestParameters.skip, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a chat object by its `session_id`. Returns 404 if not found.
     * @param {ChatApiGetChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChat(requestParameters: ChatApiGetChatRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChat(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated non-deleted chats for a specific agent.  Example: /api/v1/chats/agent/your-agent-id?skip=0&limit=10
     * @summary Retrieve paginated non-deleted chats for a specific agent.
     * @param {ChatApiGetChatsByAgentIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatsByAgentId(requestParameters: ChatApiGetChatsByAgentIdRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatsByAgentId(requestParameters.agentId, requestParameters.skip, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate invoice cost for chats within a specific time frame.
     * @param {ChatApiGetChatsCostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatsCost(requestParameters: ChatApiGetChatsCostRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatsCost(requestParameters.startDate, requestParameters.endDate, requestParameters.organizationId, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get count of all chats (including deleted) within a time frame. Can filter by agent_id and/or organization_id.  Note: When end_date is at 00:00:00 (start of a day), it will be adjusted to include the whole day. For example, if end_date is 2026-01-08T00:00:00.000Z, it will count all chats up to the end of Jan 8 (2026-01-08T23:59:59.999Z).  Example: /api/v1/chats/count?start_date=2026-01-07T00:00:00&end_date=2026-01-08T00:00:00&organization_id=org-123 This will count all chats for the whole days of Jan 7 and Jan 8.
     * @summary Get count of chats within a specific time frame.
     * @param {ChatApiGetChatsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public getChatsCount(requestParameters: ChatApiGetChatsCountRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).getChatsCount(requestParameters.startDate, requestParameters.endDate, requestParameters.agentId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the chat fields such as `forced_transfer_count` or `is_transfer` for the given `session_id`.
     * @param {ChatApiUpdateChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public updateChat(requestParameters: ChatApiUpdateChatRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).updateChat(requestParameters.sessionId, requestParameters.chatUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new chat if the given `session_id` does not exist. If it already exists, update the `is_transfer` field instead.
     * @param {ChatApiUpsertChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public upsertChat(requestParameters: ChatApiUpsertChatRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).upsertChat(requestParameters.chatCreate, options).then((request) => request(this.axios, this.basePath));
    }
}

